'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _kendoBaseComponentsVueWrapper = require('@progress/kendo-base-components-vue-wrapper');

var _KendoGridColumn = require('../KendoGridColumn');

var _KendoGridColumn2 = _interopRequireDefault(_KendoGridColumn);

var _KendoGridToolbar = require('../KendoGridToolbar');

var _KendoGridToolbar2 = _interopRequireDefault(_KendoGridToolbar);

var _GridProps = require('./GridProps');

var _GridProps2 = _interopRequireDefault(_GridProps);

var _AllowCopy = require('./AllowCopy');

var _AllowCopy2 = _interopRequireDefault(_AllowCopy);

var _ColumnMenu = require('./ColumnMenu');

var _ColumnMenu2 = _interopRequireDefault(_ColumnMenu);

var _Editable = require('./Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _Excel = require('./Excel');

var _Excel2 = _interopRequireDefault(_Excel);

var _Filterable = require('./Filterable');

var _Filterable2 = _interopRequireDefault(_Filterable);

var _Groupable = require('./Groupable');

var _Groupable2 = _interopRequireDefault(_Groupable);

var _Messages = require('./Messages');

var _Messages2 = _interopRequireDefault(_Messages);

var _NoRecords = require('./NoRecords');

var _NoRecords2 = _interopRequireDefault(_NoRecords);

var _Pageable = require('./Pageable');

var _Pageable2 = _interopRequireDefault(_Pageable);

var _Pdf = require('./Pdf');

var _Pdf2 = _interopRequireDefault(_Pdf);

var _Scrollable = require('./Scrollable');

var _Scrollable2 = _interopRequireDefault(_Scrollable);

var _Sortable = require('./Sortable');

var _Sortable2 = _interopRequireDefault(_Sortable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: _GridProps2.default,
    template: '<div>\n        <slot name="kendo-datasource"></slot>\n        <slot></slot>\n    </div>',
    mixins: [_kendoBaseComponentsVueWrapper.KendoBaseComponent, _kendoBaseComponentsVueWrapper.KendoBaseDatasourceComponent, _AllowCopy2.default, _ColumnMenu2.default, _Editable2.default, _Excel2.default, _Filterable2.default, _Groupable2.default, _Messages2.default, _NoRecords2.default, _Pageable2.default, _Pdf2.default, _Scrollable2.default, _Sortable2.default],
    mounted: function mounted() {
        this._resolveChildren();
        kendo.jQuery(this.$el).kendoGrid(this.widgetOptions);

        this.$emit('kendowidgetready', this.kendoWidget());
    },

    methods: {
        kendoWidget: function kendoWidget() {
            return kendo.jQuery(this.$el).getKendoGrid();
        },
        _resolveChildren: function _resolveChildren() {
            this.resolveChildren('columns', _KendoGridColumn2.default.name);
            this.resolveChildren('toolbar', _KendoGridToolbar2.default.name);
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@progress/kendo-grid-vue-wrapper/dist/es/KendoGrid/KendoGridMixin.js
// module id = 630
// module chunks = 0